import Page from '../page';
import ComponentNavigation from '../navigation/component-navigation';

import Alert from '../pages/components/alert.vue';
import Personalization from '../pages/components/personalization-signup.vue';
import ImageCredit from '../pages/components/image-credit.vue';
import Articles from '../pages/components/articles.vue';
import Breadcrumb from '../pages/components/breadcrumb.vue';
import DAFWidget from '../pages/components/daf-widget.vue';
import GenericModal from '../pages/components/generic-modal.vue';
import MainNav from '../pages/components/main-nav.vue';
import UtilityBar from '../pages/components/utility-bar.vue';
import TopNav from '../pages/components/top-nav.vue';
import LoginSignup from '../pages/components/login-signup.vue';
import ListingHeader from '../pages/components/listing-header.vue';
import HeroCard from '../pages/components/hero-card.vue';
import DonationHeroCard from '../pages/components/donation-hero-card.vue';
import HeroFullWidth from '../pages/components/hero-full-width.vue';
import EventList from '../pages/components/event-list.vue';
import FullWidthVideoImage from '../pages/components/full-width-video-image.vue';
import FullWidthEvent from '../pages/components/full-width-event.vue';
import InquiriesSupport from '../pages/components/inquiries-support.vue';
import Testimonial from '../pages/components/full-width-testimonial.vue';
import FullWidthHighlightCopy from '../pages/components/full-width-highlight-copy.vue';
import InlineSearch from '../pages/components/inline-search.vue';
import CeSearch from '../pages/components/ce-search.vue';
import CourseSearch from '../pages/components/course-search.vue';
import CPRTopicSearch from '../pages/components/cpr-course-search.vue';
import QualityResearchPublications from '../pages/components/quality-research-publications.vue';
import RatingWidget from '../pages/components/rating-widget.vue';
import IconNav from '../pages/components/icon-navigation.vue';
import ImageVideoCarousel from '../pages/components/image-video-carousel.vue';
import GroceryList from '../pages/components/grocery-list.vue';

import CourseInformation from '../pages/components/course-information.vue';
import VideoGallery from '../pages/components/video-gallery.vue';
import Video from '../pages/components/video.vue';
import TvPages from '../pages/components/tv-pages.vue';
import ThingsToKnow from '../pages/components/things-to-know.vue';
import ExtScript from '../pages/components/external-script.vue';
import MagicGrid from '../pages/components/magic-grid-demo-examples.vue';
import NewsletterAjax from '../pages/components/aha-newsletter-ajax-component.vue';
import FormSubmitToEmail from '../pages/components/modal-form-submit-to-email.vue';

// LIW
import LiwIntroBanner from '../pages/components/liw-intro-banner.vue';
import LiwCounterComponent from '../pages/components/liw-counter-component.vue';
import LiwMultiLogoComponent from '../pages/components/liw-multi-logo-component.vue';
import LiwFlipCardComponent from '../pages/components/liw-flip-card-component.vue';

// ECC
import ColorCodedTable from '../pages/components/ecc-color-coded-table.vue';
import ECCReferences from '../pages/components/ecc-references.vue';
import ECCSearch from '../pages/components/ecc-search.vue';
import NestedAccordion from '../pages/components/ecc-nested-accordion.vue';
import SVGMap from '../pages/components/svg-map.vue';

// Promos
import TwoColumnContentWidthPromo from '../pages/components/two-column-content-width-promo';
import TwoColumnFullWidthPromo from '../pages/components/two-column-full-width-promo';
import TwoColumnFullBleedPromo from '../pages/components/two-column-full-bleed-promo';
import ThreeColumnContentWidthPromo from '../pages/components/three-column-content-width-promo';
import ThreeColumnContentWidthPromoEnhanced from '../pages/components/three-column-content-width-promo-enhanced';
import FourColumnContentWidthIconPromo from '../pages/components/four-column-content-width-icon-promo';
import FourColumnContentWidthImagePromo from '../pages/components/four-column-content-width-image-promo';
import FourColumnFullWidthImagePromo from '../pages/components/four-column-full-width-image-promo';
import ThreeColumnFullWidthPromo from '../pages/components/three-column-full-width-promo';
import TwoThirdLinkComponent from '../pages/components/two-third-link-component';
import FullWidthEmailPromo from '../pages/components/full-width-email-promo.vue';
import HalfImageHalfCopyPromo from '../pages/components/half-image-half-copy-promo.vue';
import HalfImageHalfCopyCollapse from '../pages/components/half-image-half-copy-collapse.vue';
import OneColumnContentWidthPromo from '../pages/components/one-column-content-width-promo.vue';

import Instructions from '../pages/components/recipe-instructions.vue';
import ImpactedData from '../pages/components/impacted-data.vue';
import NutritionalFacts from '../pages/components/recipe-nutritional-facts.vue';
import QuickTips from '../pages/components/recipe-quick-tips.vue';
import RecipeSocial from '../pages/components/recipe-social.vue';

import StudentCode from '../pages/components/Student-code.vue';

import SpeedBump from '../pages/components/speed-bump.vue';
import SsoIntercept from '../pages/components/sso-intercept.vue';

import AffiliateNav from '../pages/components/affiliate-nav';
import SitecoreForms from '../pages/components/sitecore-forms';

import StrokeSymptoms from '../pages/components/stroke-symptoms';
import PromoModal from '../pages/components/promo-modal';

import SessionTimeoutModal from '../pages/components/session-timeout';
import TwoColumnParagraph from '../pages/components/two-column-paragraph';
import CardSelector from '../pages/components/card-selector';
import SwitchInput from '../pages/components/switch-input';
import ButtonCTA from '../pages/components/button-cta';

// PHD:
import adHorizontal from '../components/phd/ad-horizontal.vue';
import PhdAccordion from '../pages/components/phd-accordion.vue';
import articleListbox from '../components/phd/article-listbox.vue';
import articleListComponent from 'demo/components/phd/article-list-component.vue';
import CommunityScienceNews from '../pages/components/phd-community-science-news.vue';
import CtaBar from '../pages/components/phd-cta-bar.vue';
import CtaBarFlexible from '../pages/components/phd-cta-bar-flexible.vue';
import ImagePDFAccessibleLinks from '../pages/components/phd-image-pdf-accessible-links.vue';
import linkBox from '../components/phd/linkbox.vue';
import linkBox5050 from '../components/phd/linkbox-50-50.vue';
import LinkedList from '../components/phd/linked-list.vue';
import LinksToDetails from '../components/phd/links-to-details.vue';
import PhdCard from '../pages/components/phd-card.vue';
import PhdCouncil from '../pages/components/phd-council.vue';
import PhdMainNav from '../pages/components/phd-main-nav.vue';
import PhdMeeting from '../pages/components/phd-meeting.vue';
import NeedToKnow from '../pages/components/need-to-know.vue';
import NewsLink from '../components/phd/news-link.vue';
import NewWindowHyperlink from '../pages/components/phd-new-window-hyperlink.vue';
import NonPartnerConnections from '../pages/components/phd-non-partner-connections.vue';
import PartnerBenefits from '../pages/components/partner-benefits.vue';
import PhdArticleLink from '../pages/components/phd-article-link.vue';
import PhdCitations from '../components/phd/phd-citations.vue';
import PhdClinicalTrialComponent from '../pages/components/phd-clinical-trial-component.vue';
import PhdCommunitiesEducation from '../pages/components/phd-communities-education.vue';
import PhdDeviceDrugComponent from '../pages/components/phd-device-drug-alerts.vue';
import PhdDailyRateComparison from '../pages/components/phd-daily-rate-comparison.vue';
import PhdInstitutionalTier from '../components/phd/phd-institutional-tier.vue';
import PhdLeftNavDemo from '../components/phd/phd-left-nav-demo.vue';
import PhdLinkedListDemo from '../pages/components/phd-linked-list-demo.vue';
import PhdMediaBlock from '../components/phd/phd-media-block.vue';
import PhdMembershipRateComparison from '../pages/components/phd-membership-rate-comparison.vue';
import PhdOverallJournalComponent from '../pages/components/phd-overall-journal.vue';
import PhdReferences from '../components/phd/phd-references.vue';
import PhdVideo from '../components/phd/phd-video.vue';
import ProVolSearch from '../pages/components/phd-pro-vol-search.vue';
import PhdVolunteerSearch from '../pages/components/phd-volunteer-search.vue';
import PhdTopNav from '../pages/components/phd-top-nav.vue';
import PhdTopUtilityNav from '../pages/components/phd-top-utility-nav.vue';
import PhdUpcomingMeetings from '../components/phd/upcoming-meetings.vue';
import Profile from '../pages/components/phd-profile.vue';
import RichText from '../components/phd/rich-text.vue';
import PhdRiskCalculator from '../pages/components/phd-risk-calculator.vue';
import ScienceVolunteerModal from '../pages/components/phd-science-volunteer-modal.vue';
import SecondaryTertiaryNav from '../pages/components/phd-secondary-tertiary-nav.vue';
import SectionHeading from '../components/phd/section-heading.vue';
import SignUpPromo from '../components/phd/sign-up-promo.vue';
import TwitterFeed from '../pages/components/phd-twitter-feed.vue';
import PhdTwoCtaComponent from '../components/phd/two-cta-component.vue';
import VideoPromo from '../components/phd/video-promo.vue';
import PhdHero from '../components/phd/phd-hero.vue';

// Science News:
import ScienceNewsBoxDemo from 'demo/components/phd/science-news/demo-science-news-box.vue';
import ScienceNewsHeading from '../components/phd/science-news/science-news-heading.vue';
import ScienceNewsPromo from '../components/phd/science-news/science-news-promo.vue';
import ScienceNewsRecentList from '../components/phd/science-news/science-news-recent-list.vue';

const ComponentPages = [
    {
        path: '/components',
        // You could also have named views at the top
        components: {
            default: Page,
            'sidebar-nav': ComponentNavigation
        },
        children: [
            {
                path: '',
                redirect: 'alert'
            },
            {
                path: 'alert',
                component: Alert
            },
            {
                path: 'personalization-signup',
                component: Personalization
            },
            {
                path: 'icon-navigation',
                component: IconNav
            },
            {
                path: 'image-credit',
                component: ImageCredit
            },
            {
                path: 'newsletter-ajax',
                component: NewsletterAjax
            },
            {
                path: '/components/articles',
                component: Articles
            },
            {
                path: '/components/breadcrumb',
                component: Breadcrumb
            },
            {
                path: '/components/daf-widget',
                component: DAFWidget
            },
            {
                path: '/components/generic-modal',
                component: GenericModal
            },
            {
                path: '/components/main-nav',
                component: MainNav
            },
            {
                path: '/components/utility-bar',
                component: UtilityBar
            },
            {
                path: '/components/listing-header',
                component: ListingHeader
            },
            {
                path: '/components/hero-card',
                component: HeroCard
            },
            {
                path: '/components/donation-hero-card',
                component: DonationHeroCard
            },
            {
                path: '/components/hero-full-width',
                component: HeroFullWidth
            },
            {
                path: '/components/event-list',
                component: EventList
            },
            {
                path: '/components/full-width-video-image',
                component: FullWidthVideoImage
            },
            {
                path: '/components/full-width-event',
                component: FullWidthEvent
            },
            {
                path: '/components/top-nav',
                component: TopNav
            },
            {
                path: '/components/login-signup',
                component: LoginSignup
            },
            {
                path: '/components/inquiries-support',
                component: InquiriesSupport
            },
            {
                path: '/components/testimonial',
                component: Testimonial
            },
            {
                path: '/components/full-width-highlight-copy',
                component: FullWidthHighlightCopy
            },
            {
                path: '/components/video-gallery',
                component: VideoGallery
            },
            {
                path: '/components/two-column-content-width-promo',
                component: TwoColumnContentWidthPromo
            },
            {
                path: '/components/two-column-full-width-promo',
                component: TwoColumnFullWidthPromo
            },
            {
                path: '/components/two-column-full-bleed-promo',
                component: TwoColumnFullBleedPromo
            },
            {
                path: '/components/three-column-content-width-promo',
                component: ThreeColumnContentWidthPromo
            },
            {
                path: '/components/three-column-content-width-promo-enhanced',
                component: ThreeColumnContentWidthPromoEnhanced
            },
            {
                path: '/components/four-column-content-width-icon-promo',
                component: FourColumnContentWidthIconPromo
            },
            {
                path: '/components/four-column-content-width-image-promo',
                component: FourColumnContentWidthImagePromo
            },
            {
                path: '/components/four-column-full-width-image-promo',
                component: FourColumnFullWidthImagePromo
            },
            {
                path: '/components/three-column-full-width-promo',
                component: ThreeColumnFullWidthPromo
            },
            {
                path: '/components/two-third-link-component',
                component: TwoThirdLinkComponent
            },
            {
                path: '/components/full-width-email-promo',

                component: FullWidthEmailPromo
            },
            {
                path: '/components/half-image-half-copy-promo',
                component: HalfImageHalfCopyPromo
            },
            {
                path: '/components/half-image-half-copy-collapse',
                component: HalfImageHalfCopyCollapse
            },
            {
                path: '/components/one-column-content-width-promo',
                component: OneColumnContentWidthPromo
            },
            {
                path: '/components/recipe-instructions',
                component: Instructions
            },
            {
                path: '/components/impacted-data',
                component: ImpactedData
            },
            {
                path: '/components/grocery-list',
                component: GroceryList
            },
            {
                path: '/components/recipe-nutritional-facts',
                component: NutritionalFacts
            },
            {
                path: '/components/recipe-quick-tips',
                component: QuickTips
            },
            {
                path: '/components/recipe-social',
                component: RecipeSocial
            },
            {
                path: '/components/inline-search',
                component: InlineSearch
            },
            {
                path: '/components/ce-search',
                component: CeSearch
            },
            {
                path: 'course-search',
                component: CourseSearch
            },
            {
                path: '/components/cpr-course-search',
                component: CPRTopicSearch
            },
            {
                path: '/components/quality-research-publications',
                component: QualityResearchPublications
            },
            {
                path: 'rating-widget',
                component: RatingWidget
            },
            {
                path: 'image-carousel',
                component: ImageVideoCarousel
            },
            {
                path: '/components/stroke-symptoms',
                component: StrokeSymptoms
            },
            {
                path: '/components/promo-modal',
                component: PromoModal
            },
            {
                path: 'speed-bump',
                component: SpeedBump
            },
            {
                path: 'sso-intercept',
                component: SsoIntercept
            },
            {
                path: 'affiliate-nav',
                component: AffiliateNav
            },
            {
                path: 'sitecore-forms',
                component: SitecoreForms
            },
            {
                path: 'video',
                component: Video
            },
            {
                path: 'external-script',
                component: ExtScript
            },
            {
                path: 'magic-grid',
                component: MagicGrid
            },
            {
                path: 'liw-intro-banner',
                component: LiwIntroBanner
            },
            {
                path: 'liw-counter-component',
                component: LiwCounterComponent
            },
            {
                path: 'liw-multi-logo-component',
                component: LiwMultiLogoComponent
            },
            {
                path: 'liw-flip-card-component',
                component: LiwFlipCardComponent
            },
            {
                path: 'color-coded-table',
                component: ColorCodedTable
            },
            {
                path: 'ecc-references',
                component: ECCReferences
            },
            {
                path: 'ecc-search',
                component: ECCSearch
            },
            {
                path: 'nested-accordion',
                component: NestedAccordion
            },
            {
                path: 'svg-map',
                component: SVGMap
            },
            {
                path: '/components/course-information',
                component: CourseInformation
            },
            {
                path: '/components/student-code',
                component: StudentCode
            },
            {
                path: 'rating-widget',
                component: RatingWidget
            },
            {
                path: 'session-timeout',
                component: SessionTimeoutModal
            },
            {
                path: 'two-column-paragraph',
                component: TwoColumnParagraph
            },
            {
                path: 'tv-pages',
                component: TvPages
            },
            {
                path: 'things-to-know',
                component: ThingsToKnow
            },
            {
                path: 'phd-institutional-tier',
                component: PhdInstitutionalTier
            },
            {
                path: 'phd-left-nav-demo',
                component: PhdLeftNavDemo
            },
            {
                path: 'phd-linked-list-demo',
                component: PhdLinkedListDemo
            },
            {
                path: 'phd-membership-rate-comparison',
                component: PhdMembershipRateComparison
            },
            {
                path: 'phd-media-block',
                component: PhdMediaBlock
            },
            {
                path: 'phd-daily-rate-comparison',
                component: PhdDailyRateComparison
            },
            {
                path: 'card-selector',
                component: CardSelector
            },
            {
                path: 'ad-horizontal',
                component: adHorizontal
            },
            {
                path: 'phd-accordion',
                component: PhdAccordion
            },
            {
                path: 'article-listbox',
                component: articleListbox
            },
            {
                path: 'phd-article-link',
                component: PhdArticleLink
            },
            {
                path: 'article-list-component',
                component: articleListComponent
            },
            {
                path: 'phd-article-link',
                component: PhdArticleLink
            },
            {
                path: 'phd-citations',
                component: PhdCitations
            },
            {
                path: 'community-science-news',
                component: CommunityScienceNews
            },
            {
                path: 'phd-cta-bar',
                component: CtaBar
            },
            {
                path: 'phd-cta-bar-flexible',
                component: CtaBarFlexible
            },
            {
                path: 'image-pdf-accessible-links',
                component: ImagePDFAccessibleLinks
            },
            {
                path: 'phd-clinical-trial-component',
                component: PhdClinicalTrialComponent
            },
            {
                path: 'phd-council',
                component: PhdCouncil
            },
            {
                path: 'phd-communities-education',
                component: PhdCommunitiesEducation
            },
            {
                path: 'phd-device-drug-alerts',
                component: PhdDeviceDrugComponent
            },
            {
                path: 'link-box',
                component: linkBox
            },
            {
                path: 'link-box-50-50',
                component: linkBox5050
            },
            {
                path: 'linked-list',
                component: LinkedList
            },
            {
                path: 'links-to-details',
                component: LinksToDetails
            },
            {
                path: 'phd-card',
                component: PhdCard
            },
            {
                path: 'phd-main-nav',
                component: PhdMainNav
            },
            {
                path: 'phd-meeting',
                component: PhdMeeting
            },
            {
                path: 'phd-overall-journal',
                component: PhdOverallJournalComponent
            },
            // {
            //     path: 'phd-membership-rate-comparison',
            //     component: PhdMembershipRateComparison
            // },
            {
                path: 'need-to-know',
                component: NeedToKnow
            },
            {
                path: 'phd-news-link',
                component: NewsLink
            },
            {
                path: 'new-window-hyperlink',
                component: NewWindowHyperlink
            },
            {
                path: 'non-partner-connections',
                component: NonPartnerConnections
            },
            {
                path: 'partner-benefits',
                component: PartnerBenefits
            },
            {
                path: 'phd-references',
                component: PhdReferences
            },
            {
                path: 'phd-video',
                component: PhdVideo
            },
            {
                path: 'phd-volunteer-search',
                component: PhdVolunteerSearch
            },
            {
                path: 'phd-pro-vol-search',
                component: ProVolSearch
            },
            {
                path: 'phd-top-nav',
                component: PhdTopNav
            },
            {
                path: 'phd-top-utility-nav',
                component: PhdTopUtilityNav
            },
            {
                path: 'phd-upcoming-meetings',
                component: PhdUpcomingMeetings
            },
            {
                path: 'phd-profile',
                component: Profile
            },
            {
                path: 'phd-risk-calculator',
                component: PhdRiskCalculator
            },
            {
                path: 'rich-text',
                component: RichText
            },
            {
                path: 'phd-science-volunteer-modal',
                component: ScienceVolunteerModal
            },
            {
                path: 'science-news-box',
                component: ScienceNewsBoxDemo
            },
            {
                path: 'science-news-heading',
                component: ScienceNewsHeading
            },
            {
                path: 'science-news-promo',
                component: ScienceNewsPromo
            },
            {
                path: 'science-news-recent-list',
                component: ScienceNewsRecentList
            },
            {
                path: 'secondary-tertiary-nav',
                component: SecondaryTertiaryNav
            },
            {
                path: 'section-heading',
                component: SectionHeading
            },
            {
                path: 'sign-up-promo',
                component: SignUpPromo
            },
            {
                path: 'video-promo',
                component: VideoPromo
            },
            {
                path: 'twitter-feed',
                component: TwitterFeed
            },
            {
                path: 'two-cta-component',
                component: PhdTwoCtaComponent
            },
            {
                path: 'switch-input',
                component: SwitchInput
            },
            {
                path: 'button-cta',
                component: ButtonCTA
            },
            {
                path: 'phd-hero',
                component: PhdHero
            },
            {
                path: 'modal-form-submit-to-email',
                component: FormSubmitToEmail
            }
        ]
    }
];

export default ComponentPages;



// WEBPACK FOOTER //
// ./demo/routes/components.js